import { styled } from "@mui/system";
import { Spinner as BootstrapSpinner } from "react-bootstrap";

const FullScreenSpinnerWrapper = styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
});

const Spinner = () => {
    return (
        <FullScreenSpinnerWrapper>
            <BootstrapSpinner animation="border" variant="primary" />
        </FullScreenSpinnerWrapper>
    );
};

export default Spinner;
